import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import { PenLine } from 'lucide-react';

function SignatureComponent({ node }) {
  const { id, label } = node.attrs;

  return (
    <NodeViewWrapper
      id={id}
      data-field-id={id}
      className="inline-flex align-middle"
    >
      <span
        className="
          inline-flex
          items-center
          gap-1.5
          rounded-md
          border
          border-dashed
          border-blue-300
          bg-blue-50/50
          px-2.5
          py-1.5
          text-xs
          font-medium
          text-blue-700
          cursor-default
          whitespace-nowrap
        "
      >
        <PenLine size={13} />

        <span>{label || 'Signature'}</span>
      </span>
    </NodeViewWrapper>
  );
}

export const Signature = Node.create({
  name: 'signature',

  group: 'inline',

  inline: true,

  atom: true,

  addAttributes() {
    return {
      id: {
        default: null,
      },

      label: {
        default: 'Signature',
      },

      required: {
        default: true,
      },

      assignedUsers: {
        default: [],
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'signature',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['signature', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(SignatureComponent);
  },
});
